export const CURRENCY_MAP = {
  ALL: 'Lek', // Albania Lek
  AFN: '؋', // Afghanistan Afghani
  ARS: '$', // Argentina Peso
  AWG: 'ƒ', // Aruba Guilder
  AUD: '$', // Australia Dollar
  AZN: '₼', // Azerbaijan Manat
  BSD: '$', // Bahamas Dollar
  BBD: '$', // Barbados Dollar
  BYN: 'Br', // Belarus Ruble
  BZD: 'BZ$', // Belize Dollar
  BMD: '$', // Bermuda Dollar
  BOB: '$b', // Bolivia Bolíviano
  BAM: 'KM', // Bosnia and Herzegovina Convertible Mark
  BWP: 'P', // Botswana Pula
  BGN: 'лв', // Bulgaria Lev
  BRL: 'R$', // Brazil Real
  BND: '$', // Brunei Darussalam Dollar
  KHR: '៛', // Cambodia Riel
  CAD: '$', // Canada Dollar
  KYD: '$', // Cayman Islands Dollar
  CLP: '$', // Chile Peso
  CNY: '¥', // China Yuan Renminbi
  COP: '$', // Colombia Peso
  CRC: '₡', // Costa Rica Colon
  CUP: '₱', // Cuba Peso
  CZK: 'Kč', // Czech Republic Koruna
  DKK: 'kr', // Denmark Krone
  DOP: 'RD$', // Dominican Republic Peso
  XCD: '$', // East Caribbean Dollar
  EGP: '£', // Egypt Pound
  SVC: '$', // El Salvador Colon
  EUR: '€', // Euro Member Countries
  FKP: '£', // Falkland Islands (Malvinas) Pound
  FJD: '$', // Fiji Dollar
  GHS: '¢', // Ghana Cedi
  GIP: '£', // Gibraltar Pound
  GTQ: 'Q', // Guatemala Quetzal
  GGP: '£', // Guernsey Pound
  GYD: '$', // Guyana Dollar
  HNL: 'L', // Honduras Lempira
  HKD: 'HK$', // Hong Kong Dollar
  HUF: 'Ft', // Hungary Forint
  ISK: 'kr', // Iceland Krona
  INR: '₹', // India Rupee
  IDR: 'Rp', // Indonesia Rupiah
  IRR: '﷼', // Iran Rial
  IMP: '£', // Isle of Man Pound
  ILS: '₪', // Israel Shekel
  JMD: 'J$', // Jamaica Dollar
  JPY: '¥', // Japan Yen
  JEP: '£', // Jersey Pound
  KZT: 'лв', // Kazakhstan Tenge
  KPW: '₩', // Korea (North) Won
  KRW: '₩', // Korea (South) Won
  KGS: 'лв', // Kyrgyzstan Som
  LAK: '₭', // Laos Kip
  LBP: '£', // Lebanon Pound
  LRD: '$', // Liberia Dollar
  MKD: 'ден', // Macedonia Denar
  MYR: 'RM', // Malaysia Ringgit
  MUR: '₨', // Mauritius Rupee
  MXN: '$', // Mexico Peso
  MNT: '₮', // Mongolia Tughrik
  MAD: 'د.إ', // Moroccan-dirham
  MZN: 'MT', // Mozambique Metical
  NAD: '$', // Namibia Dollar
  NPR: '₨', // Nepal Rupee
  ANG: 'ƒ', // Netherlands Antilles Guilder
  NZD: '$', // New Zealand Dollar
  NIO: 'C$', // Nicaragua Cordoba
  NGN: '₦', // Nigeria Naira
  NOK: 'kr', // Norway Krone
  OMR: '﷼', // Oman Rial
  PKR: '₨', // Pakistan Rupee
  PAB: 'B/.', // Panama Balboa
  PYG: 'Gs', // Paraguay Guarani
  PEN: 'S/.', // Peru Sol
  PHP: '₱', // Philippines Peso
  PLN: 'zł', // Poland Zloty
  QAR: '﷼', // Qatar Riyal
  RON: 'lei', // Romania Leu
  RUB: '₽', // Russia Ruble
  SHP: '£', // Saint Helena Pound
  SAR: '﷼', // Saudi Arabia Riyal
  RSD: 'Дин.', // Serbia Dinar
  SCR: '₨', // Seychelles Rupee
  SGD: '$', // Singapore Dollar
  SBD: '$', // Solomon Islands Dollar
  SOS: 'S', // Somalia Shilling
  ZAR: 'R', // South Africa Rand
  LKR: '₨', // Sri Lanka Rupee
  SEK: 'kr', // Sweden Krona
  CHF: 'Fr.', // Switzerland Franc
  SRD: '$', // Suriname Dollar
  SYP: '£', // Syria Pound
  TWD: 'NT$', // Taiwan New Dollar
  THB: '฿', // Thailand Baht
  TTD: 'TT$', // Trinidad and Tobago Dollar
  TRY: '₺', // Turkey Lira
  TVD: '$', // Tuvalu Dollar
  UAH: '₴', // Ukraine Hryvnia
  AED: 'د.إ', // UAE-Dirham
  GBP: '£', // United Kingdom Pound
  USD: '$', // United States Dollar
  UYU: '$U', // Uruguay Peso
  UZS: 'лв', // Uzbekistan Som
  VEF: 'Bs', // Venezuela Bolívar
  VND: '₫', // Viet Nam Dong
  YER: '﷼', // Yemen Rial
  ZWD: 'Z$', // Zimbabwe Dollar
};

// Array of currencies that should appear first in lists
const PRIMARY_CURRENCIES = new Set(['GBP', 'EUR', 'USD', 'CAD', 'SGD']);

// Array of currency codes with primary currencies first
export const CURRENCY_LIST = [
  ...PRIMARY_CURRENCIES,
  ...Object.keys(CURRENCY_MAP).filter((key) => !PRIMARY_CURRENCIES.has(key)),
];

// Array of currency key label pairs
export const CURRENCY_OPTIONS = CURRENCY_LIST.map((key) => {
  return { key, label: key };
});

// Array of currency key label pairs with symbol
export const CURRENCY_OPTIONS_WITH_SYMBOL = CURRENCY_LIST.map((key) => {
  return {
    key,
    label: `${key} (${CURRENCY_MAP[key as keyof typeof CURRENCY_MAP]})`,
  };
});

// List of currencies that require the ISO code to also be
// displayed to avoid confusion with other currencies
export const CURRENCY_SHOW_ISO_CODE = [
  'ALL',
  'ANG',
  'ARS',
  'AUD',
  'AWG',
  'BBD',
  'BMD',
  'BND',
  'BSD',
  'BYN',
  'CAD',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'DKK',
  'EGP',
  'FJD',
  'FKP',
  'GGP',
  'GIP',
  'GYD',
  'HNL',
  'IMP',
  'INR',
  'ISK',
  'JEP',
  'JPY',
  'KYD',
  'LBP',
  'LKR',
  'LRD',
  'MUR',
  'MXN',
  'NAD',
  'NOK',
  'NPR',
  'NZD',
  'PHP',
  'PKR',
  'SBD',
  'SCR',
  'SEK',
  'SGD',
  'SHP',
  'SRD',
  'SVC',
  'SYP',
  'TVD',
  'USD',
  'XCD',
];

// List of currencies that should show the symbol on the right
export const CURRENCY_RIGHT_HAND_SYMBOL = [
  'AED',
  'AFN',
  'IRR',
  'MAD',
  'OMR',
  'QAR',
  'SAR',
  'YER',
];

// List of currencies that don't use decimal places (zero-decimal currencies)
// These currencies should not be divided by 100 when converting from cents/smallest unit
export const ZERO_DECIMAL_CURRENCIES = [
  'BIF', // Burundi Franc
  'CLP', // Chilean Peso
  'DJF', // Djibouti Franc
  'GNF', // Guinean Franc
  'JPY', // Japanese Yen
  'KMF', // Comorian Franc
  'KRW', // Korean Won
  'PYG', // Paraguayan Guaraní
  'RWF', // Rwandan Franc
  'UGX', // Ugandan Shilling
  'UYI', // Uruguay Peso en Unidades Indexadas
  'VND', // Vietnamese Dong
  'VUV', // Vanuatu Vatu
  'XAF', // Central African CFA Franc
  'XOF', // West African CFA Franc
  'XPF', // CFP Franc
];

/**
 * Check if a currency uses decimal places
 * @param currency - ISO currency code
 * @returns true if currency uses decimal places, false if it's zero-decimal
 */
export const isCurrencyWithDecimals = (currency?: string | null): boolean => {
  if (!currency) {
    return true; // Default to using decimals if currency is not provided
  }
  return !ZERO_DECIMAL_CURRENCIES.includes(currency);
};
